
const initialState = {
    customerList: null,
    organizationList: null,
    scanHistoryList: null,
    domainList: null,
    whoisInformation: null,
    subdomainList: null,
    aRecord: null,
    aaaRecord: null,
    cnameRecord: null,
    mxRecord: null,
    nsRecord: null,
    soaRecord: null,
    txtRecord: null,
    subDomainTechnologies: null,
    sslCertificateList: null,
    ipAddressList: null,
    ipAddressSubDomainList: null,
    ipAddressPortList: null,
    technologyList: null,
    endPointsList: null,
    sslCertificates: null,
    mobileAppsList: null,
    validateResponse: null,
    deletMobileAppResponse: null,
    cerStats: null,
    cerDataList: null,
    gitLeaksList: null,
    sensitiveExpoList: null,
    sensitiveEndpointsList: null,
    jsSecretsEndpointsList: null,
    leakedCredentialsList: null,
    leakedCredentialsData: null,
    botnetLeaksList: null,
    botnetLeakedData: null,
    ransomwareGroupListList: null,
    ransomwereGroupData: null,
    externalDetectedList: null,
    subdomainTakeOverList: null,
    cvesList: null,
    cnvdList: null,
    sslVulnerabilitiesList: null,
    exposedPanelList: null,
    defaultLoginList: null,
    misconfigurationList: null,
    otherVulnerabilitiesList: null,
    afftectedEndpointList: null,
    similarDomainList: null,
    similarDomainSSL: null,
    associatedDomainList: null,
    associatedDomainSSL: null,
    scanInfoStats: null,
    updateStatusList: null,
    portfolioRiskList: null,
    portfolioDomainList: null,
    portfolioCustomersList: null,
    portfolioCustomerSelected: null,
    portfolioStatus: null,
    backlinkAuditList: null,
}

const listTypeMap = {
    subdomainTakeOverList: 'subdomainTakeOverList',
    cvesList: "cvesList",
    cnvdList: "cnvdList",
    sslVulnerabilitiesList: "sslVulnerabilitiesList",
    exposedPanelList: "exposedPanelList",
    defaultLoginList: "defaultLoginList",
    misconfigurationList: "misconfigurationList",
    otherVulnerabilitiesList: "otherVulnerabilitiesList",
    externalDetectedList: 'externalDetectedList',
};

export default function scanInfoReducer(state=initialState, action) {
    switch(action.type) {
        case 'SCAN_INFO_CUSTOMER_LIST_SUCCESS':
            return {
                ...state,
                customerList: action.payload
            }
        case 'SCAN_INFO_ORGANIZATION_LIST_SUCCESS': 
            return {
                ...state,
                organizationList: action.payload
            }
        case 'SCAN_INFO_DOMAIN_LIST_SUCCESS':
            return {
                ...state,
                domainList: action.payload
            }
        case 'SCAN_INFO_RESET_DOMAIN_LIST':
            return {
                ...state,
                domainList: null
            }
        case 'SCAN_INFO_SCAN_HISTORY_SUCCESS':
            return {
                ...state,
                scanHistoryList: action.payload
            }
        case 'SCAN_INFO_RESET_SCAN_HISTORY_LIST':
            return {
                ...state,
                scanHistoryList: null
            }
        case 'WHOIS_INFORMATION_SUCCESS':
            return {
                ...state,
                whoisInformation: action.payload
            }
        case 'SUBDOMAIN_LIST_SUCCESS':
            return {
                ...state,
                subdomainList: action.payload
            }
        case 'RESET_SUBDOMAIN_LIST':
            return {
                ...state,
                subdomainList: null
            }
        case 'GET_ARECORD_SUCCESS':
            return {
                ...state,
                aRecord: action.payload
            }
        case 'GET_AAARECORD_SUCCESS':
            return {
                ...state,
                aaaRecord: action.payload
            }
        case 'GET_CNAMERECORD_SUCCESS':
            return {
                ...state,
                cnameRecord: action.payload
            }
        case 'GET_MXRECORD_SUCCESS':
            return {
                ...state,
                mxRecord: action.payload
            }
        case 'GET_NSRECORD_SUCCESS':
            return {
                ...state,
                nsRecord: action.payload
            }
        case 'GET_SOARECORD_SUCCESS':
            return {
                ...state,
                soaRecord: action.payload
            }
        case 'GET_TXTRECORD_SUCCESS':
            return {
                ...state,
                txtRecord: action.payload
            }
        case 'RESET_DNS_RECORD_LIST' :
            return {
                ...state,
                aRecord: null,
                aaaRecord: null,
                cnameRecord: null,
                mxRecord: null,
                nsRecord: null,
                soaRecord: null,
                txtRecord: null
            }
        case 'SUBDOMAIN_TECHNOLOGIES_SUCCESS':
            return {
                ...state,
                subDomainTechnologies: action.payload
            }
        case 'SSL_CERTIFICATE_SUCCESS':
            return {
                ...state,
                sslCertificateList: action.payload
            }
        case 'IP_ADDRESS_LIST_SUCCESS':
            return {
                ...state,
                ipAddressList: action.payload
            }
        case 'RESET_IP_ADDRESS_LIST':
            return {
                ...state,
                ipAddressList: null
            }
        case 'IP_ADDRESS_SUBDOMAIN_LIST_SUCCESS':
            return {
                ...state,
                ipAddressSubDomainList: action.payload
            }
        case 'IP_ADDRESS_PORT_LIST_SUCCESS':
            return {
                ...state,
                ipAddressPortList: action.payload
            }
        case 'TECHNOLOGY_LIST_SUCCESS':
            return {
                ...state,
                technologyList: action.payload
            }
        case 'RESET_TECHNOLOGY_LIST' :
            return {
                ...state,
                technologyList: null
            }
        case 'ENDPOINTS_LIST_SUCCESS':
            return {
                ...state,
                endPointsList: action.payload
            }
        case 'SSL_CERTIFICATE_LIST_SUCCESS':
            return {
                ...state,
                sslCertificates: action.payload
            }
        case 'RESET_SSL_CERTIFICATE_LIST':
            return {
                ...state,
                sslCertificates: null
            }
        case 'MOBILE_APPS_LIST_SUCCESS' :
            return {
                ...state,
                mobileAppsList: action.payload
            }
        case 'RESET_MOBILE_APPS_LIST' :
            return {
                ...state,
                mobileAppsList: null
            }
        case 'VALIDATE_SUCCESS' :
            return {
                ...state,
                validateResponse: action.payload
            }
        case 'RESET_VALIDATE_SUCCESS':
            return {
                ...state,
                validateResponse: null
            }
        case 'DELETE_MOBILE_APP_SUCCESS' :
            return {
                ...state,
                deletMobileAppResponse: action.payload
            }
        case 'RESET_DELETE_MOBILE_APP' :
            return {
                ...state,
                deletMobileAppResponse: null
            }
        case 'CER_STATS_SUCCESS':
            return {
                ...state,
                cerStats: action.payload
            }
        case 'RESET_CER_STATUS':
            return {
                ...state,
                cerStats: null
            }
        case 'CER_DATA_SUCCESS':
            return {
                ...state,
                cerDataList: action.payload
            }
        case 'RESET_CER_DATA_LIST':
            return {
                ...state,
                cerDataList: null
            }
        case 'GIT_LEAKS_SUCCESS':
            return {
                ...state,
                gitLeaksList: action.payload
            }
        case 'RESET_GIT_LEAKS_LIST':
            return {
                ...state,
                gitLeaksList: null
            }
        case 'JS_SECRETS_LEAKS_SUCCESS':
            return {
                ...state,
                jsSecretsList: action.payload
            }
        case 'RESET_JS_SECRETS_LIST':
            return {
                ...state,
                jsSecretsList: null
            }
        case 'SENSITIVE_EXPO_LIST_SUCCESS':
            return {
                ...state,
                sensitiveExpoList: action.payload
            }
        case 'RESET_SENSITIVE_EXPO_LIST':
            return {
                ...state,
                sensitiveExpoList: null
            }
        case 'SENSITIVE_ENDPOINTS_LIST_SUCCESS':
            return {
                ...state,
                sensitiveEndpointsList: action.payload
            }
        case 'JS_SECRETS_ENDPOINTS_LIST_SUCCESS':
            return {
                ...state,
                jsSecretsEndpointsList: action.payload
            }
        case 'LEAKED_CREDENTALS_LIST_SUCCESS' :
            return {
                ...state,
                leakedCredentialsList: action.payload
            }
        case 'LEAKED_CREDENTALS_DATA_SUCCESS' :
            return {
                ...state,
                leakedCredentialsData: action.payload
            }
        case 'BOTNET_LEAKS_LIST_SUCCESS' :
            return {
                ...state,
                botnetLeaksList: action.payload
            }
        case 'BOTNET_LEAKS_DATA_SUCCESS' :
            return {
                ...state,
                botnetLeakedData: action.payload
            }
        case 'RANSOMEWARE_LIST_SUCCESS':
            return {
                ...state,
                ransomwareGroupListList: action.payload
            }
        case 'RANSOMEWARE_DATA_SUCCESS':
            return {
                ...state,
                ransomwereGroupData: action.payload
            }
        case 'EXTERNAL_DETECTED_LIST_SUCCESS': {
            const key = listTypeMap[action.listType] || 'externalDetectedList';

            return {
                ...state,
                [key]: action.payload
            };
        } 
            
        case 'RESET_EXTERNAL_DETECTED_LIST': {
            const key = listTypeMap[action.listType] || 'externalDetectedList';

            return {
                ...state,
                [key]: null
            };
        }

        case 'AFFECTED_ENDPOINTS_LIST_SUCCESS':
            return {
                ...state,
                afftectedEndpointList: action.payload
            }
        case 'SIMILAR_DOMIAN_LIST_SUCCESS':
            return {
                ...state,
                similarDomainList: action.payload
            }
        case 'SIMILAR_DOMAIN_SSL_SUCCESS':
            return {
                ...state,
                similarDomainSSL: action.payload
            }
        case 'ASSOCIATED_DOMAIN_LIST_SUCCESS':
            return {
                ...state,
                associatedDomainList: action.payload
            }
        case 'RESET_ASSOCIATED_DOMAIN_LIST':
            return {
                ...state,
                associatedDomainList: null
            }
        case 'ASSOCIATED_DOMAIN_SSL_SUCCESS':
            return {
                ...state,
                associatedDomainSSL: action.payload
            }
        case 'SCAN_INFO_STATS_SUCCESS':
            return {
                ...state,
                scanInfoStats: action.payload
            }
        case 'RESET_SCAN_INFO_SUCCESS':
            return {
                ...state,
                scanInfoStats: null
            }
        case 'UPDATE_DATA_LIST_SUCCESS':
            return {
                ...state,
                updateStatusList: action.payload
            }
        case 'RESET_UPDATE_DATA_LIST':
            return {
                ...state,
                updateStatusList: null
            }
        case 'PORTFOLIO_RISK_LIST_SUCCESS':
            return {
                ...state,
                portfolioRiskList: action.payload
            }
        case 'PORTFOLIO_RISK_DOMAIN_LIST_SUCCESS':
            return {
                ...state,
                portfolioDomainList: action.payload
            }
        case 'PORTFOLIO_CUSTOMER_LIST_SUCCESS':
            return {
                ...state,
                portfolioCustomersList: action.payload
            }
        case 'PORTFOLIO_CUSTOMER_SELECTED_VALUE' :
            return {
                ...state,
                portfolioCustomerSelected: action.payload
            }
        case 'RESET_PORTFOLIO_DOMAIN_LIST' :
            return {
                ...state,
                portfolioDomainList: null
            }
        case 'PORTFOLIO_RISK_STATUS_SUCCESS':
            return {
                ...state,
                portfolioStatus: action.payload
            }
        case 'BACKLINK_AUDIT_LIST':
            return {
                ...state,
                backlinkAuditList: action.payload
            }
        case 'RESET_BACK_LINK_LIST':
            return {
                ...state,
                backlinkAuditList: null
            }
        default:
            return state;
    }
}